import { Injectable } from '@angular/core';
import { BaseService } from '@core/base.service';
import { Observable } from 'rxjs';
import { FairLaunchLog } from 'src/app/page/fair-launch/models/fair-launch.models';
import {
    CreateMigrationSniperPayload,
    CreateTokensAccountsResponse,
    MigrationSniperInterface,
    MigrationSnipeValidation,
    UpdateMigrationSniperPayload,
} from 'src/app/page/migration-sniper/migration-sniper.interfaces';

@Injectable({ providedIn: 'root' })
export class MigrationSniperApiService {
    constructor(private readonly http: BaseService) {}

    getList(): Observable<MigrationSniperInterface[]> {
        return this.http.get('migration-snipes');
    }

    create(data: CreateMigrationSniperPayload): Observable<MigrationSniperInterface> {
        return this.http.create('migration-snipes', data);
    }

    update(data: UpdateMigrationSniperPayload): Observable<MigrationSniperInterface> {
        return this.http.update(`migration-snipes/${data.id}`, data);
    }

    getById(id: number): Observable<MigrationSniperInterface> {
        return this.http.get(`migration-snipes/${id}`);
    }

    archive(migrationSniperId: number): Observable<void> {
        return this.http.update(`migration-snipes/${migrationSniperId}/archive`, {});
    }

    startMigration(migrationSniperId: number): Observable<void> {
        return this.http.create(`migration-snipes/${migrationSniperId}/start`, {});
    }

    stop(migrationSniperId: number): Observable<void> {
        return this.http.create(`migration-snipes/${migrationSniperId}/stop`, {});
    }

    sellAll(migrationSniperId: number): Observable<string[]> {
        return this.http.create(`migration-snipes/${migrationSniperId}/sell-all`, {});
    }

    validate(id: number): Observable<MigrationSnipeValidation> {
        return this.http.create(`migration-snipes/${id}/validate`, {});
    }

    createTokenAccounts(migrationSniperId: number): Observable<CreateTokensAccountsResponse[]> {
        return this.http.create(`migration-snipes/${migrationSniperId}/create-token-accounts`, {});
    }

    getLogs(migrationSniperId: number): Observable<FairLaunchLog[]> {
        return this.http.get(`migration-snipes/${migrationSniperId}/logs`);
    }
}
